import createAsyncActions from 'shared/redux/helpers/create-async-actions';


const ACTIONS = createAsyncActions('CLIENT.VIDEO_URLS.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function (videoItem, force = false) {
  return function (dispatch, getState) {
    const { videoUrlsCache, appSettings } = getState();

    if (!force && (!videoItem || videoUrlsCache[videoItem.id])) {
      return;
    }

    const params = { videoItem };

    dispatch(START(params));

    return videoItem.getVideoUrls(appSettings.instance)
      .then(
        function (response) {
          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL(params, response));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/video-urls/fetch.js